
import CONSTANTS from '../constants';
import globalState from '../state';
import solicitante from './solicitante';
import { combineReducers } from 'redux';

let fichaInscricao = (state = globalState.fichaInscricao, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.CHANGE_GENERICO]: () => {
            var QueId = payload.QueId;
            var opcId = payload.opcId;

            var ListOpcao = [...state.listRespostas[QueId].ListOpcao];
            if (payload.multiplo) {
                if (payload.multiplo.acao === 'add') {
                    ListOpcao.push({ OpcId: payload.multiplo.opcId, OpcRespTexto: '' });
                } else if (payload.multiplo.acao === 'remove') {
                    ListOpcao = ListOpcao.filter((item) => {
                        return item.OpcId !== payload.multiplo.opcId;
                    });
                }
            } else if (opcId && opcId > 0) {
                ListOpcao = [{ OpcId: opcId, OpcRespTexto: '' }];
            } else if (opcId === 0) {
                ListOpcao = [];
            }
            var listResp = {
                ...state.listRespostas,
                [QueId]: {
                    ...state.listRespostas[QueId],
                    QueId: QueId,
                    ListOpcao: ListOpcao
                }
            };
            return {
                ...state,
                listRespostas: listResp
            };
        },
        [CONSTANTS.CHANGE_TEXTO_OUTROS]: () => {
            var listOpcao = state.listRespostas[payload.queId].ListOpcao

            var listResp = {
                ...state.listRespostas,
                [payload.queId]: {
                    ...state.listRespostas[payload.queId],
                    ListOpcao: listOpcao.map((op) => {
                        if (op.OpcId === payload.opcId) {
                            return { ...op, OpcResOutra: payload.opcResOutra };
                        }
                        return op;
                    })
                }
            };
            return {
                ...state,
                listRespostas: listResp
            };
        },
        [CONSTANTS.CARREGAR_QUESTOES.LOADING]: () => {
            return {
                ...state,
                listQuestoes: [],
                carregandoQuestoes: true
            };
        },
        [CONSTANTS.SETAR_SIM_NAO]: () => {

            var listResp = {
                ...state.listRespostas,
                [payload.queId]: {
                    ...state.listRespostas[payload.queId],
                    RespSimNao: payload.respSimNao
                }
            };
            //se existe algum dependente e respSimNao == true
            //entao remove a resposta dos que dependem
            var listQueDependemDestaQueId = state.listQuestoes.filter((item) => {
                return item.QueIdDependenteSIM === payload.queId;
            });
            if (listQueDependemDestaQueId.length > 0) {
                listQueDependemDestaQueId.forEach((item)=>{
                    listResp[item.QueId] = {
                        ...listResp[item.QueId],
                        RespSimNao: undefined, QueId: item.QueId, ListOpcao: []
                    };
                });
            }

            return {
                ...state,
                listRespostas: listResp
            };
        },

        [CONSTANTS.CARREGAR_QUESTOES.SUCCESS]: () => {
            var listRespostas = {};
            payload.listQuestoes.forEach((item) => {
                listRespostas[item.QueId] = {
                    RespSimNao: void (0),
                    QueId: item.QueId,
                    // OpcId: 0,// U
                    ListOpcao: []
                };
            });
            return {
                ...state,
                listRespostas: listRespostas,
                listQuestoes: payload.listQuestoes,
                anjoLogado: payload.anjoLogado,
                carregandoQuestoes: false
            };
        },
        
        [CONSTANTS.CARREGAR_QUESTOES.ERROR]: () => {
            return {
                ...state,
                listQuestoes: [],
                carregandoQuestoes: false
            };
        },

        [CONSTANTS.GRAVAR_RESPOSTAS.LOADING]: () => {
            return { ...state, gravando: true };
        },

        [CONSTANTS.GRAVAR_RESPOSTAS.ERROR]: () => {
            return { ...state, gravando: false };
        },
        
        [CONSTANTS.GRAVAR_RESPOSTAS.SUCCESS]: () => {
            return { ...state, gravando: false, respondeu: true, msgOutCadastroAnjo: payload.msgOutCadastroAnjo };
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type](state, action);
    }
    return state;
};


let globalError = (state = globalState.globalError, action) => {

    let actions = {
        [CONSTANTS.SET_ERROR]: () => {
            var err = action.error ? action.payload && action.payload.message : "";
            if (err && err.indexOf("Informix") >= 0 || err && err.indexOf('Unexpected') >= 0) {
                err = "Ocorreu um erro interno";

            }
            return err;
        }
    };

    if (actions[action.type]) {
        return actions[action.type](state, action);
    }

    return state;
};


let globalMsg = (state = globalState.globalMsg, action) => {

    let actions = {
        [CONSTANTS.SET_MSG]: () => {

            return action.payload;
        }
    };

    if (actions[action.type]) {
        return actions[action.type](state, action);
    }

    return state;
};

export default combineReducers({
    globalMsg,
    globalError,
    solicitante,
    fichaInscricao
});
